import "/polyfills/closest";
import "/polyfills/nodelist-foreach";
import events from "/events";
import "/services/facebook-login";
import "/services/google-login";
import globals from "/utils/globals";

const updateToken = token => {
  globals.token = token;
  document.querySelector("meta[name=csrf-token]").setAttribute("content", token);
  const inputs = document.querySelectorAll("input[name=authenticity_token]");
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];
    input.value = token;
    const submit = input.closest("form").querySelector("input[type='submit'][disabled]");
    if (submit && !submit.classList.contains("js-keep-disabled-on-auth")) {
      submit.removeAttribute("disabled");
    }
  }
};

events.on("setup:ready", config => {

  if (!config) {
    return;
  }

  const token = config.authenticity_token;

  // Update all authenticity tokens for cache busting

  updateToken(token);

  events.on("modal:auth-popup:step:signup:opened", () => updateToken(token));
  events.on("modal:auth-popup:step:login:opened", () => updateToken(token));
  events.on("modal:leaving-popup:opened", () => updateToken(token));

  if (config.guest) {
    document.querySelectorAll(".user-logged-out-item").forEach(el => {
      el.classList.remove("user-logged-out-item");
    });
    events.emit("blinksV2_user_logged_out");
  } else {
    document.querySelectorAll(".user-logged-in-item").forEach(el => {
      el.classList.remove("user-logged-in-item");
    });

    // Remove blocks requested for specifc users
    document.querySelectorAll("[data-user-segment*='" + config.segment + "']").forEach(el => {
      el.removeAttribute("data-user-segment");
    });
  }
});
